import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { cellWidth } from '~/detail/styled';

export const TotalContainerStyled = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    width: 100%;
  `};
`;
export const TotalCellStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  pl: { sm: '500' },
  py: { sm: '500' },
  justifyContent: { sm: 'flex-start' },
})`
  width: ${cellWidth};
`;
